import { Injectable } from '@angular/core';
import { DataService } from '../data.service';

@Injectable({
  providedIn: 'root'
})
export class AutogestionService {

  private readonly urlBase = '/autogestion'
  constructor( private dataService: DataService ) { }

  async resetPassword( patientId: number, password: string): Promise<boolean> {
    const params = { patientId, password };
    return await this.dataService.post<boolean>(`${ this.urlBase }/ResetPassword`, params)
    .toPromise();
  }
}
